import { useQuery } from '@tanstack/react-query';
import { walletOptions } from '../../constants/wallet';
export function useWallet() {
    const { data, isLoading, isSuccess } = useQuery(walletOptions.get());
    return {
        wallet: data ?? undefined,
        loadingWallet: isLoading,
        isSuccess,
    };
}
